import { FIELD_NAMES, FIELD_TYPES } from './constants';

export const pseudoTagStringToGQL = (string) => string.replace(/\[</g, '[--').replace(/>\]/g, '--]');

export const pseudoTagStringFromGQL = (string) => string.replace(/\[--/g, '[<').replace(/--\]/g, '>]');

export const removePseudoTags = (text) => {
  const arrOfTagsAndText = text.split(/(\[<.*?\[*>])/g);
  return arrOfTagsAndText.map((item) => {
    const match = item.match(/\[<.*?:.*?].*?\[.*?]/);
    if (!match) return item;
    return item.match(/\](.*)\[/)[1];
  }).join('');
};

export function taxiFieldNameToStandardFieldName(taxiFieldName) {
  switch (taxiFieldName) {
    case FIELD_NAMES.CONSENT_GDPR:
    case FIELD_NAMES.CONSENT_NON_GDPR:
      return FIELD_NAMES.LEAD_SHARE_OPT_IN;
    case FIELD_NAMES.CP_DEGREE_OFFERING:
      return FIELD_NAMES.DEGREE_OFFERING;
    default:
      return taxiFieldName;
  }
}

export function standardFieldNameToTaxiFieldName(standardFieldName, fieldType) {
  switch (standardFieldName) {
    case FIELD_NAMES.LEAD_SHARE_OPT_IN:
      return fieldType === FIELD_TYPES.NON_GDPR_CONSENT ? FIELD_NAMES.CONSENT_NON_GDPR : FIELD_NAMES.CONSENT_GDPR;
    case FIELD_NAMES.DEGREE_OFFERING:
      return fieldType === FIELD_TYPES.DEGREE_OFFERING ? FIELD_NAMES.CP_DEGREE_OFFERING : FIELD_NAMES.DEGREE_OFFERING;
    default:
      return standardFieldName;
  }
}
